import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  const loadCount = () => api.get("/notifications/unread-count").then((r) => setCount(r.data.count || 0)).catch(() => {});
  const loadList = () => api.get("/notifications").then((r) => setItems(r.data || [])).catch(() => {});

  useEffect(() => {
    loadCount();
    const t = setInterval(loadCount, 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next) {
      await loadList();
      if (count > 0) { try { await api.post("/notifications/read-all"); setCount(0); } catch (_) { /* ignore */ } }
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button data-testid="notif-bell" onClick={toggle}
        className="relative h-8 w-8 grid place-items-center rounded-full text-slate-500 hover:text-slate-900 hover:bg-slate-100 transition-colors">
        <Bell size={18} />
        {count > 0 && (
          <span data-testid="notif-badge"
            className="absolute -top-0.5 -right-0.5 min-w-[16px] h-[16px] px-1 rounded-full text-[10px] font-bold text-white grid place-items-center"
            style={{ backgroundColor: "#C20511" }}>{count > 9 ? "9+" : count}</span>
        )}
      </button>
      {open && (
        <div data-testid="notif-dropdown"
          className="absolute right-0 mt-2 w-80 max-h-96 overflow-auto bg-white border border-slate-200 rounded-xl shadow-xl z-50">
          <div className="px-4 py-3 border-b border-slate-100 flex items-center gap-2">
            <Bell size={15} style={{ color: "#C20511" }} />
            <span className="text-sm font-bold text-slate-900" style={{ fontFamily: "Manrope, sans-serif" }}>Notifications</span>
          </div>
          {items.length === 0 ? (
            <div className="px-4 py-8 text-center text-sm text-slate-400" data-testid="notif-empty">You&apos;re all caught up.</div>
          ) : (
            items.map((n) => (
              <div key={n.id} data-testid={`notif-item-${n.id}`}
                className={`px-4 py-3 border-b border-slate-50 ${n.read ? "opacity-70" : ""}`}>
                <div className="text-sm text-slate-700 leading-snug">{n.message}</div>
                <div className="text-[11px] text-slate-400 mt-1">{n.created_at ? new Date(n.created_at).toLocaleString() : ""}</div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
